/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Sync_FailedInputs */

const en_booking_sync_failed = /** @type {(inputs: Booking_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused or not delivered`)
};

/**
* | output |
* | --- |
* | "Refused or not delivered" |
*
* @param {Booking_Sync_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_sync_failed = /** @type {((inputs?: Booking_Sync_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sync_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_sync_failed(inputs)
});